export { default } from "./useFacultyAdderReducer";
export {
  FACULTY_ADDER_ACTIONS,
  FIELDS_ERROR_MESSAGE,
} from "./useFacultyAdderReducer";
